import { render, staticRenderFns } from "./VirtualDesktopItem.vue?vue&type=template&id=5bd9b77c&scoped=true"
import script from "./VirtualDesktopItem.vue?vue&type=script&lang=ts"
export * from "./VirtualDesktopItem.vue?vue&type=script&lang=ts"
import style0 from "./VirtualDesktopItem.vue?vue&type=style&index=0&id=5bd9b77c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd9b77c",
  null
  
)

export default component.exports